import { DataTable } from '@/components/atoms';
import { TAG_COLOR } from '@/utils/constants/colors';
import { Tag } from 'pepsico-ds';

// Move the Tag rendering logic to a separate component
const IncludeExcludeTag = ({ includeExclude }) => {
  const color = includeExclude === 'Include' ? TAG_COLOR.GRAY_100 : TAG_COLOR.RED_150;
  return <Tag color={color} text={includeExclude} isCopyable={false} />;
};

// Define a reusable function for cell rendering
const renderIncludeExcludeTag = (includeExclude) => (
  <IncludeExcludeTag includeExclude={includeExclude} />
);

const ReviewProductsTable = () => {
  const columns = [
    { columnKey: 'name', header: 'Name' },
    { columnKey: 'product_id', header: 'Product Id' },
    { columnKey: 'status', header: 'Status' },
    { columnKey: 'size', header: 'Size' },
    { columnKey: 'category', header: 'Category' },
    { columnKey: 'brand', header: 'Brand' },
    {
      columnKey: 'include_exclude',
      header: 'Include/Exclude',
      cellData: (ctx) => renderIncludeExcludeTag(ctx.row.original.include_exclude), // Use the reusable function
    },
  ];

  const tableData = [
    {
      name: 'Sales Target NAme',
      product_id: '100',
      status: 'Active',
      size: '250',
      category: 'Category',
      brand: 'Brand',
      include_exclude: 'Include',
    },
    {
      name: 'Sales Target NAme',
      product_id: '100',
      status: 'Active',
      size: '250',
      category: 'Category',
      brand: 'Brand',
      include_exclude: 'Include',
    },
    {
      name: 'Sales Target NAme',
      product_id: '100',
      status: 'Active',
      size: '250',
      category: 'Category',
      brand: 'Brand',
      include_exclude: 'Include',
    },
  ];

  return (
    <div className="products-table simple">
      <DataTable columns={columns} data={tableData} isDark showColumnFilters={false} />
    </div>
  );
};

export default ReviewProductsTable;